const classics = [
  {
    title: 'Cha Yen',
    price: '₱110 | ₱120',
    tags: 'Authentic Thailand Milk Tea', 
  },
  {
    title: 'Nom Yen',
    price: '₱110 | ₱125',
    tags: 'Authentic Thailand Pink Milk',
  },
  {
    title: 'Koko Yen',
    price: '₱100 | ₱110',
    tags: 'Authentic Thailand Cocoa',
  },
  {
    title: 'Signature Milk Tea',
    price: '₱85 | ₱95',
    tags: 'Signature Milk Tea | Black & Honey Pearls',
  },
  {
    title: 'Roasted Okinawa',
    price: '₱80 | ₱90',
    tags: 'Milk Tea | Roasted Okinawa | Black & Honey Pearls',
  },
];

const specialtydrinks = [
  {
    title: 'Dark Cocoa Sea Salt',
    price: '₱130 | ₱160',
    tags: 'Dark Cocoa | Sea Salt Cream',
  },
  {
    title: "White Rabbit Sea Salt",
    price: '₱130 | ₱160',
    tags: 'White Rabbit Milk Tea | Sea Salt Cream',
  },
  {
    title: 'Matcha Milk Tea Sea Salt',
    price: '₱120 | ₱150',
    tags: 'Matcha Milk Tea | Sea Salt Cream',
  },
  {
    title: 'Pink Milk Tea',
    price: '₱85 | ₱95',
    tags: 'Nom Yen | Cheesecake',
  },
  {
    title: 'Hazelnut',
    price: '₱80 | ₱90',
    tags: 'Signature Milk Tea | Hazelnut | Cheesecake',
  },
];

export default { classics, specialtydrinks };
